module.exports = __webpack_public_path__ + "img/et.a82a19b3.svg";